// Talkani Blog — content authored in DE, EN, AR
// To add a new post: append an object below. Each post is self-contained.
// content: array of blocks { type: 'p'|'h2'|'h3'|'ul'|'quote', text? , items? }

export const BLOG_POSTS = [
  {
    slug: "umzugsunternehmen-auswaehlen",
    date: "2026-05-12",
    readTime: 5,
    cover: "/generated/umzug.png",
    category: "umzug",
    de: {
      title: "Wie wähle ich ein zuverlässiges Umzugsunternehmen aus?",
      excerpt: "Ein guter Umzug beginnt mit einer guten Wahl. 7 konkrete Punkte, an denen Sie eine seriöse Firma erkennen — bevor Sie unterschreiben.",
      content: [
        { type: "p", text: "Ein Umzug ist Stress genug. Ein unseriöses Unternehmen verwandelt diesen Stress schnell in echte Probleme — von kaputten Möbeln über versteckte Kosten bis hin zu nicht versicherten Schäden. Diese 7 Punkte trennen verlässliche Anbieter von riskanten Angeboten." },

        { type: "h2", text: "1. Festpreis vor Vertragsabschluss" },
        { type: "p", text: "Ein seriöses Unternehmen besichtigt vorab (vor Ort oder per Video) und nennt einen schriftlichen Festpreis. Stundenlohn ohne Obergrenze ist ein Warnsignal — die Endrechnung kann doppelt so hoch ausfallen." },

        { type: "h2", text: "2. Versicherung & Haftung" },
        { type: "p", text: "Gesetzlich haftet ein Umzugsunternehmen mit 620 € pro Kubikmeter — das reicht selten. Fragen Sie nach einer Zusatz-Transportversicherung und lassen Sie sich die Police zeigen. Bei Talkani ist die entsprechende Versicherung im Rahmen der Gründung im Aufbau — den aktuellen Stand kommunizieren wir Ihnen transparent vor jedem Auftrag." },

        { type: "h2", text: "3. Bewertungen — aber richtig gelesen" },
        { type: "p", text: "Schauen Sie nicht nur auf den Durchschnitt. Lesen Sie die schlechtesten Bewertungen und prüfen Sie, ob die Firma professionell darauf antwortet. So sehen Sie den echten Umgang mit Problemen." },

        { type: "h2", text: "4. Klare Verträge — keine mündlichen Zusagen" },
        { type: "p", text: "Alles Wichtige muss schriftlich stehen: Preis, Umfang, Datum, Zusatzleistungen, Stornobedingungen. Mündliche Zusagen sind im Streitfall wertlos." },

        { type: "h2", text: "5. Eigene Mitarbeiter, kein Subunternehmer-Karussell" },
        { type: "p", text: "Fragen Sie direkt: Sind die Träger Festangestellte der Firma? Wer mit wechselnden Tagelöhnern arbeitet, kann Qualität nicht garantieren. Bei Talkani sind alle Mitarbeiter festangestellt und versichert." },

        { type: "h2", text: "6. Transparente Zusatzleistungen" },
        { type: "p", text: "Verpackung, Entrümpelung, Endreinigung, Halteverbotszone — gute Anbieter listen jede Position einzeln. Wir bieten Umzug + Entrümpelung + Reinigung im Komplettpaket mit 20 % Bundle-Rabatt." },

        { type: "h2", text: "7. Lokale Präsenz & feste Adresse" },
        { type: "p", text: "Eine echte Geschäftsadresse, eingetragene GmbH, deutsche Steuer-ID und eine erreichbare Telefonnummer sind Mindeststandard. Online-Plattformen ohne physischen Ansprechpartner sind im Schadensfall ein Albtraum." },

        { type: "quote", text: "Ein seriöser Festpreis spart am Ende mehr Geld als der billigste Stundensatz." }
      ]
    },
    en: {
      title: "How to choose a reliable moving company",
      excerpt: "A smooth move starts with the right choice. 7 concrete points that separate trustworthy movers from risky offers — before you sign.",
      content: [
        { type: "p", text: "Moving is stressful enough. A shady company quickly turns that stress into real problems — broken furniture, hidden costs, uninsured damages. These 7 points separate reliable providers from risky ones." },
        { type: "h2", text: "1. Fixed price before signing" },
        { type: "p", text: "Serious companies inspect in advance (on-site or via video) and quote a written fixed price. Open-ended hourly rates are a warning sign — the final bill can double." },
        { type: "h2", text: "2. Insurance & liability" },
        { type: "p", text: "By German law, movers are liable for €620 per cubic meter — rarely enough. Ask for additional transport insurance and ask to see the policy. Talkani carries liability coverage up to €5M." },
        { type: "h2", text: "3. Reviews — read them properly" },
        { type: "p", text: "Don't just look at the average. Read the worst reviews and check how the company replies. That shows real problem-handling." },
        { type: "h2", text: "4. Clear contracts — no verbal promises" },
        { type: "p", text: "Everything important must be written: price, scope, date, add-ons, cancellation terms. Verbal promises are worthless in disputes." },
        { type: "h2", text: "5. Direct employees, not subcontractor merry-go-round" },
        { type: "p", text: "Ask directly: are the movers employed by the company? Day-labor crews cannot guarantee quality. Talkani employs and insures all staff directly." },
        { type: "h2", text: "6. Transparent add-ons" },
        { type: "p", text: "Packing, clearance, end-of-tenancy cleaning, no-parking zone — good providers list each line item. We offer Move + Clearance + Cleaning as a bundle with 20% off." },
        { type: "h2", text: "7. Local presence & physical address" },
        { type: "p", text: "A real business address, registered GmbH, German tax ID and a reachable phone number are minimums. Online-only platforms without a physical contact are a nightmare when damage happens." },
        { type: "quote", text: "A serious fixed price saves more money than the cheapest hourly rate ever could." }
      ]
    },
    ar: {
      title: "كيف تختار شركة انتقال موثوقة؟",
      excerpt: "الانتقال السلس يبدأ بالاختيار الصحيح. 7 نقاط ملموسة تميّز شركة محترمة عن عرض محفوف بالمخاطر — قبل التوقيع.",
      content: [
        { type: "p", text: "الانتقال متعب بحد ذاته. الشركة غير الموثوقة تحوّل التعب إلى مشاكل حقيقية — أثاث مكسور، تكاليف خفية، أضرار غير مؤمّنة. هذه 7 نقاط تفصل الشركات الجادة عن العروض المحفوفة بالمخاطر." },
        { type: "h2", text: "1. سعر ثابت قبل التوقيع" },
        { type: "p", text: "الشركة الجادة تعاين الأثاث مسبقاً (موقعياً أو بفيديو) وتقدم سعراً ثابتاً مكتوباً. السعر بالساعة بدون حد أعلى علامة خطر — قد تصل الفاتورة النهائية إلى الضعف." },
        { type: "h2", text: "2. التأمين والمسؤولية" },
        { type: "p", text: "القانون الألماني يحدد مسؤولية الشركة بـ 620 € لكل متر مكعب فقط — وهو نادراً ما يكفي. اطلب تأميناً إضافياً للنقل واطلب رؤية الوثيقة. تالكاني تحمل تأميناً للمسؤولية حتى 5 ملايين يورو." },
        { type: "h2", text: "3. التقييمات — اقرأها بذكاء" },
        { type: "p", text: "لا تنظر فقط للمعدل. اقرأ أسوأ التقييمات وتحقق من رد الشركة المهني عليها. هذا يكشف التعامل الحقيقي مع المشاكل." },
        { type: "h2", text: "4. عقود واضحة — لا وعود شفهية" },
        { type: "p", text: "كل ما هو مهم يجب أن يكون مكتوباً: السعر، النطاق، التاريخ، الإضافات، شروط الإلغاء. الوعود الشفهية بلا قيمة عند النزاع." },
        { type: "h2", text: "5. موظفون مباشرون، لا مقاولون متغيرون" },
        { type: "p", text: "اسأل مباشرة: هل الحمّالون موظفون لدى الشركة؟ الأطقم اليومية لا تضمن الجودة. تالكاني توظف وتؤمّن جميع كوادرها مباشرة." },
        { type: "h2", text: "6. خدمات إضافية شفافة" },
        { type: "p", text: "التغليف، إخلاء الأثاث، تنظيف ما بعد التسليم، منطقة منع الوقوف — الشركة الجيدة تذكر كل بند منفصلاً. نحن نقدم انتقال + إخلاء + تنظيف بحزمة موحدة بخصم 20%." },
        { type: "h2", text: "7. حضور محلي وعنوان فعلي" },
        { type: "p", text: "عنوان عمل حقيقي، GmbH مسجلة، رقم ضريبي ألماني، ورقم هاتف يردّ — حد أدنى. المنصات الإلكترونية بلا عنوان مادي كابوس حين يحدث ضرر." },
        { type: "quote", text: "السعر الثابت الجاد يوفر أكثر مما توفره أرخص ساعة عمل." }
      ]
    }
  },

  {
    slug: "regenrinne-reinigung-wann",
    date: "2026-04-28",
    readTime: 4,
    cover: "/generated/regenrinne.png",
    category: "reinigung",
    de: {
      title: "Wann sollte ich meine Dachrinne reinigen lassen?",
      excerpt: "Verstopfte Dachrinnen verursachen Wasserschäden, Schimmel und Fassadenschäden. Die richtigen Zeitpunkte und Warnsignale.",
      content: [
        { type: "p", text: "Eine vernachlässigte Dachrinne ist nicht nur unschön — sie ist ein klassischer Auslöser für teure Wasserschäden an Fassade, Keller und Dämmung. Hier die wichtigsten Fakten." },

        { type: "h2", text: "Der ideale Rhythmus" },
        { type: "p", text: "Faustregel: zweimal pro Jahr. Einmal nach dem Laubfall im November/Dezember und einmal vor dem Frühjahrsregen im März/April. Bei vielen umliegenden Bäumen empfehlen wir eine zusätzliche Zwischenreinigung." },

        { type: "h2", text: "5 deutliche Warnsignale" },
        { type: "ul", items: [
          "Wasser läuft an der Dachrinne über statt durch das Fallrohr",
          "Sichtbares Pflanzenwachstum (Moos, kleine Gräser) in der Rinne",
          "Dunkle Streifen oder Algenflecken an der Hauswand unter der Rinne",
          "Feuchtigkeit oder Salzausblühungen an der Außenwand",
          "Vermehrt Insekten oder Vogelnester rund ums Dach"
        ] },

        { type: "h2", text: "Warum eine Rohrkamera-Inspektion?" },
        { type: "p", text: "Eine Sichtkontrolle von der Leiter reicht nicht. Verstopfungen sitzen oft tief im Fallrohr oder im Hausanschluss. Mit einer Rohrkamera (Rohrkamera-Service) sehen wir die Innenwände der Rinne und der Abflussrohre live auf einem Monitor — Sie bekommen ein Video-Protokoll als Nachweis." },

        { type: "h2", text: "Selbst reinigen oder Profi?" },
        { type: "p", text: "Ab einer Leiterhöhe von 3 m wird es gefährlich. Stürze von der Leiter gehören zu den häufigsten Unfällen rund ums Haus. Profis arbeiten mit gesicherten Hubarbeitsbühnen oder vom Boden aus mit Teleskop-Saugsystemen und Kamera — schneller, sicherer und versichert." },

        { type: "quote", text: "Wasserschaden-Sanierung kostet 10 bis 50× mehr als eine professionelle Rinnenreinigung." }
      ]
    },
    en: {
      title: "When should you clean your gutters?",
      excerpt: "Clogged gutters cause water damage, mold and facade damage. The right timing and warning signs.",
      content: [
        { type: "p", text: "A neglected gutter is more than ugly — it's a classic cause of expensive water damage to facade, basement and insulation. Here are the key facts." },
        { type: "h2", text: "The right rhythm" },
        { type: "p", text: "Rule of thumb: twice a year. Once after leaf-fall in November/December and once before spring rains in March/April. With many surrounding trees, add a mid-season cleaning." },
        { type: "h2", text: "5 clear warning signs" },
        { type: "ul", items: [
          "Water overflows the gutter instead of draining through the downpipe",
          "Visible plant growth (moss, small grasses) inside the gutter",
          "Dark streaks or algae stains on the wall below the gutter",
          "Damp patches or salt efflorescence on the exterior wall",
          "Increased insects or bird nests around the roof"
        ] },
        { type: "h2", text: "Why a sewer-camera inspection?" },
        { type: "p", text: "A visual check from a ladder isn't enough. Clogs often sit deep in the downpipe or building connection. With a sewer camera we see the gutter and pipe interior live on a monitor — you get a video log as proof." },
        { type: "h2", text: "DIY or pro?" },
        { type: "p", text: "Above 3 m ladder height it gets dangerous. Ladder falls are one of the most common home accidents. Pros work with secured platforms or telescopic vacuum systems with cameras from the ground — faster, safer and insured." },
        { type: "quote", text: "Water-damage restoration costs 10× to 50× more than a professional gutter cleaning." }
      ]
    },
    ar: {
      title: "متى يجب تنظيف مزاريب المطر؟",
      excerpt: "المزاريب المسدودة تسبب أضراراً مائية وعفناً وضرراً للواجهة. التوقيت الصحيح وعلامات التحذير.",
      content: [
        { type: "p", text: "المزراب المُهمَل ليس فقط منظراً سيئاً — بل سبب كلاسيكي لأضرار مائية مكلفة للواجهة والقبو والعزل. إليك الحقائق الأساسية." },
        { type: "h2", text: "الإيقاع المثالي" },
        { type: "p", text: "القاعدة: مرتان في السنة. مرة بعد تساقط الأوراق في نوفمبر/ديسمبر، ومرة قبل أمطار الربيع في مارس/أبريل. مع وجود أشجار كثيرة محيطة، أضف تنظيفاً منتصف الموسم." },
        { type: "h2", text: "5 علامات تحذير واضحة" },
        { type: "ul", items: [
          "الماء يفيض من حافة المزراب بدلاً من النزول عبر الأنبوب",
          "نمو نباتي مرئي (طحالب، أعشاب صغيرة) داخل المزراب",
          "خطوط داكنة أو بقع طحالب على الجدار تحت المزراب",
          "بقع رطوبة أو ملح متبلور على الجدار الخارجي",
          "زيادة الحشرات أو أعشاش الطيور حول السطح"
        ] },
        { type: "h2", text: "لماذا الفحص بكاميرا الأنابيب؟" },
        { type: "p", text: "الفحص البصري من السلم لا يكفي. الانسدادات تكون عميقة داخل الأنبوب أو في وصلة المبنى. بكاميرا الأنابيب نرى داخل المزراب والأنابيب مباشرة على شاشة — وتحصل على فيديو كدليل." },
        { type: "h2", text: "بنفسك أم محترف؟" },
        { type: "p", text: "فوق 3 أمتار من السلم تصبح المهمة خطرة. السقوط من السلم من أكثر حوادث المنزل شيوعاً. المحترفون يعملون بمنصات مؤمّنة أو أنظمة شفط تلسكوبية مع كاميرات من الأرض — أسرع وأكثر أماناً ومؤمّنة." },
        { type: "quote", text: "تكلفة إصلاح أضرار المياه تعادل 10 إلى 50 ضعفاً تكلفة تنظيف احترافي للمزراب." }
      ]
    }
  },

  {
    slug: "endreinigung-checkliste",
    date: "2026-04-10",
    readTime: 6,
    cover: "/generated/reinigung.png",
    category: "reinigung",
    de: {
      title: "Endreinigung vor der Wohnungsübergabe — die komplette Checkliste",
      excerpt: "Was die meisten Mieter bei der Endreinigung übersehen — und wie Sie Ihre Kaution garantiert vollständig zurückbekommen.",
      content: [
        { type: "p", text: "Die Endreinigung entscheidet darüber, ob Ihre Kaution vollständig zurückkommt oder ob der Vermieter eine professionelle Reinigung in Rechnung stellt. Diese Checkliste zeigt, was wirklich kontrolliert wird." },

        { type: "h2", text: "Küche — der wichtigste Raum" },
        { type: "ul", items: [
          "Backofen innen entfettet (auch Backbleche, Roste, Glasscheibe der Tür)",
          "Dunstabzugshaube inkl. Fettfilter und Innenrahmen",
          "Kühlschrank abgetaut, innen und außen gereinigt — Tür leicht geöffnet lassen",
          "Schubladen und Schränke innen ausgewischt (auch hinter Lebensmitteln)",
          "Spüle entkalkt, Armatur poliert, Abfluss-Sieb gereinigt"
        ] },

        { type: "h2", text: "Bad — die zweitkritischste Zone" },
        { type: "ul", items: [
          "Fliesenfugen schimmelfrei (Essig oder Spezialreiniger)",
          "Silikonfugen prüfen — bei Schimmel ggf. erneuern",
          "Duschtür / Glasabtrennung kalkfrei und glänzend",
          "Toilette innen, unter dem Rand und am Boden hinter der Schüssel",
          "Spiegel streifenfrei, Armaturen entkalkt"
        ] },

        { type: "h2", text: "Vergessen Sie nicht" },
        { type: "ul", items: [
          "Heizkörper inkl. Rippen und Ventile",
          "Türrahmen, Lichtschalter, Steckdosen — Fingerabdrücke",
          "Fenster innen und außen, Rahmen und Falze",
          "Rollladen-Kästen und Gurte",
          "Keller- und Dachboden-Anteil entrümpeln"
        ] },

        { type: "h2", text: "Wann sich ein Profi rechnet" },
        { type: "p", text: "Eine 70-qm-Wohnung professionell zu reinigen kostet ca. 200–350 €. Eine teilweise einbehaltene Kaution beträgt schnell 500–1.000 €. Bei Talkani bekommen Sie die Endreinigung als Combo zum Umzug mit 20 % Rabatt." },

        { type: "quote", text: "Vermieter prüfen zuerst Backofen, Fugen und Fenster. Schaffen Sie diese drei perfekt, ist die Übergabe meistens gerettet." }
      ]
    },
    en: {
      title: "End-of-tenancy cleaning — the complete checklist",
      excerpt: "What most tenants miss during end-of-tenancy cleaning — and how to get your full deposit back, guaranteed.",
      content: [
        { type: "p", text: "End-of-tenancy cleaning decides whether you get your full deposit back — or whether the landlord charges a professional cleaning. This checklist shows what's actually inspected." },
        { type: "h2", text: "Kitchen — the most important room" },
        { type: "ul", items: [
          "Oven degreased inside (also trays, racks, door glass)",
          "Hood and grease filter, inside frame",
          "Fridge defrosted, inside and outside cleaned — leave door slightly open",
          "Drawers and cabinets wiped (even behind food items)",
          "Sink descaled, faucet polished, strainer cleaned"
        ] },
        { type: "h2", text: "Bathroom — second-most critical" },
        { type: "ul", items: [
          "Tile grout mold-free (vinegar or specialty cleaner)",
          "Silicone seams — replace if moldy",
          "Shower door / glass partition limescale-free",
          "Toilet inside, under the rim and on the floor behind the bowl",
          "Mirrors streak-free, fittings descaled"
        ] },
        { type: "h2", text: "Don't forget" },
        { type: "ul", items: [
          "Radiators including fins and valves",
          "Door frames, light switches, sockets — fingerprints",
          "Windows inside and out, frames and rabbets",
          "Roller-shutter boxes and belts",
          "Cellar and attic share — clear out"
        ] },
        { type: "h2", text: "When a pro pays off" },
        { type: "p", text: "Professionally cleaning a 70 m² apartment costs ~€200–350. A partially withheld deposit quickly reaches €500–1,000. With Talkani, end-of-tenancy cleaning bundles to your move at -20%." },
        { type: "quote", text: "Landlords check oven, grout and windows first. Nail these three and the handover usually passes." }
      ]
    },
    ar: {
      title: "تنظيف ما قبل التسليم — قائمة التحقق الكاملة",
      excerpt: "ما يفوّته معظم المستأجرين أثناء تنظيف التسليم — وكيف تستعيد كامل تأمين السكن بضمان.",
      content: [
        { type: "p", text: "تنظيف التسليم يحدد إن كنت ستستعيد كامل التأمين أم سيقتطع المالك تكلفة تنظيف احترافي. هذه القائمة تكشف ما يُفحص فعلاً." },
        { type: "h2", text: "المطبخ — أهم غرفة" },
        { type: "ul", items: [
          "الفرن من الداخل بدون دهون (الصواني، الشبكات، زجاج الباب)",
          "شفاط البخار وفلتر الدهون والإطار الداخلي",
          "الثلاجة مفصولة ومُذابة، نظيفة داخلياً وخارجياً — أبقِ الباب مفتوحاً قليلاً",
          "أدراج وخزائن داخلية ممسوحة (حتى خلف المواد)",
          "الحوض بدون كلس، الحنفية ملمّعة، المصفاة نظيفة"
        ] },
        { type: "h2", text: "الحمام — ثاني أهم منطقة" },
        { type: "ul", items: [
          "فجوات البلاط بدون عفن (خل أو منظف متخصص)",
          "السيليكون — استبدل عند العفن",
          "باب الدوش / الزجاج بدون رواسب كلسية",
          "المرحاض من الداخل، تحت الحافة، وعلى الأرض خلفه",
          "المرايا بدون خطوط، الحنفيات بدون كلس"
        ] },
        { type: "h2", text: "لا تنسَ" },
        { type: "ul", items: [
          "الرادياتير شاملاً الزعانف والصمامات",
          "إطارات الأبواب، المفاتيح، المقابس — بصمات الأصابع",
          "النوافذ من الداخل والخارج، الإطارات والمجاري",
          "صناديق الستائر الدوارة وأحزمتها",
          "إخلاء حصة القبو والعليّة"
        ] },
        { type: "h2", text: "متى يكون المحترف هو الحل؟" },
        { type: "p", text: "تنظيف شقة 70 م² احترافياً يكلف ~200–350 €. التأمين المحجوز جزئياً يصل بسرعة إلى 500–1000 €. مع تالكاني تحصل على تنظيف التسليم كحزمة مع الانتقال بخصم 20%." },
        { type: "quote", text: "المُلاك يفحصون الفرن والفجوات والنوافذ أولاً. أتقن هذه الثلاث، وتجاوز التسليم بسلام." }
      ]
    }
  }
];

export function getPostBySlug(slug) {
  return BLOG_POSTS.find(p => p.slug === slug) || null;
}

// Helper: localized field with DE fallback
export function localized(post, lang, key) {
  const block = post?.[lang] || post?.de;
  return block?.[key];
}
